<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <cliente-list
        ref="list"
        @update="update"
        @delete="remove"
        @show="show"
      />
    </template>

    <cliente-create
      v-if="creating"
      :open="creating"
      v-on:itemCreated="onItemCreated"
      v-on:close="creating = false"
    />

    <cliente-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      v-on:itemUpdated="onItemUpdated"
      v-on:close="updating = false"
    />

    <cliente-show
      v-if="showing"
      :open="showing"
      :item="itemToShow"
      v-on:close="showing = false"
    />

    <!-- <cliente-delete v-if="deleting"
                         :open="deleting"
                         :item="itemToDelete"
                         v-on:itemDeleted="onItemDeleted"
                         v-on:close="deleting=false"
        /> -->

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import ClienteCreate from "../ClienteCreate";
import ClienteUpdate from "../ClienteUpdate";
// import ClienteDelete from "../ClienteDelete";
import ClienteShow from "../ClienteShow";
import ClienteList from "../ClienteList";

import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "ClienteCrud",
  components: {
    CrudLayout,
    Snackbar,
    ClienteCreate,
    ClienteUpdate,
    // ClienteDelete,
    ClienteShow,
    ClienteList,
  },
  data() {
    return {
      title: "cliente.title",
      subtitle: "cliente.subtitle",
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    };
  },
  methods: {
    //On
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    onItemDeleted() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.deleted");
    },
    //Open
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    show(item) {
      this.showing = true;
      this.itemToShow = item;
    },
    remove(item) {
      this.deleting = true;
      this.itemToDelete = item;
    },
  },
};
</script>
